import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { setType } from 'store/entities/submissions';

import Filter, { FilterButton } from 'components/UIComponents/Filter';
import { Column } from 'components/UIComponents/Layout';

const ObligationFilter = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { submissionsListLoading, type } = useSelector(
    state => state.submissions
  );

  return (
    <Column
      mobile={{ size: 12 }}
      tablet={{size: 6}}
      desktop={{ size: 12 }}
      widescreen={{ size: 6 }}
      fullhd={{ size: 3 }}
    >
      <Filter>
        <FilterButton
          value="INTERESTED"
          id="showFollowedObligationsButton"
          selectedValue={type}
          disabled={submissionsListLoading}
          onClick={() => dispatch(setType('INTERESTED'))}
        >
          {t('datagate.external.submissions.filter.following')}
        </FilterButton>
        <FilterButton
          value="ALL"
          id="showAllObligationsButton"
          selectedValue={type}
          disabled={submissionsListLoading}
          onClick={() => dispatch(setType('ALL'))}
        >
          {t('datagate.external.submissions.filter.all')}
        </FilterButton>
      </Filter>
    </Column>
  );
};

export default ObligationFilter;
